import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pkvppv-chart"
export default class extends Controller {
	static targets = ["chartdata", "chartloading"]

	connect() {
		this.setChartData()
		chartPkvPpv.init()
	}

	chartdataTargetConnected() {
		// Wenn ein neues Target Div mit den Chartdaten das alte ersetzt (durch Stream oder replace)
		// muss das Chart aktualisiert werden
		this.setChartData()
		chartPkvPpv.update()
	}

	chartloadingTargetConnected() {
		// console.log("ChartloadingTargetConnected")
		chartPkvPpv.showLoading()
	}

	chartloadingTargetDisconnected() {
		// console.log("ChartloadingTargetDisconnected")
		chartPkvPpv.hideLoading()
	}

	setChartData() {
		chartPkvPpv.data = JSON.parse(this.chartdataTarget.dataset.chartdata)
	}
}
